/** Find character before file extension */
const IMAGE_SIZE_POSITION = /(?=\.(?:jpg|jpeg|gif|png|webp)(?:\?v=\d+)?$)/i

/**
 * Remove protocol from URL path
 *
 * @param path - URL path
 * @returns URL path without protocol
 */
const removeProtocol = (path: string) => path.replace(/http(s)?:/, '')

/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src - Image source
 * @param size - Image sizes
 * @returns Resized image source
 */
export default (src: string, size = '') => {
  if (!size || size === 'master') {
    return removeProtocol(src)
  }

  return removeProtocol(src.replace(IMAGE_SIZE_POSITION, `_${size}`))
}
